import React, { useContext } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { LoggedInUserContext } from 'common/contexts';
import { getPrivilegesFromUser } from 'common/utils/user';
import {
  MODIFY_ATTRIBUTE_TYPE,
  MODIFY_DEAD_ATTRIBUTE,
  VIEW_AUDIT_LOG,
} from 'common/constants/privileges';
import AdminAttributesPage from './AttributesPage';
import AdminAuditLogPage from './AuditLogPage';
import DerivedAttributesPage from './DerivedAttributesPage';
import DeadAttributesPage from './DeadAttributesPage';

const AdminPage = () => {
  const { loggedInUser } = useContext(LoggedInUserContext);

  const privileges = getPrivilegesFromUser(loggedInUser);

  if (!loggedInUser.person_id) {
    return <div>Loading...</div>;
  }

  return (
    <Switch>
      <Route path="/admin/attributes">
        {privileges.includes(MODIFY_ATTRIBUTE_TYPE) ? (
          <AdminAttributesPage />
        ) : (
          <Redirect to="/users" />
        )}
      </Route>
      <Route path="/admin/derived_attributes">
        {privileges.includes(MODIFY_ATTRIBUTE_TYPE) ? (
          <DerivedAttributesPage />
        ) : (
          <Redirect to="/users" />
        )}
      </Route>
      <Route path="/admin/dead_attributes">
        {privileges.includes(MODIFY_DEAD_ATTRIBUTE) ? (
          <DeadAttributesPage />
        ) : (
          <Redirect to="/users" />
        )}
      </Route>
      <Route path="/admin/audit-log">
        {privileges.includes(VIEW_AUDIT_LOG) ? <AdminAuditLogPage /> : <Redirect to="/users" />}
      </Route>
      <Redirect from="/admin" to="/admin/attributes" />
      <Redirect from="/admin/:path" to="/admin/attributes" />
    </Switch>
  );
};

export default AdminPage;
